import React, { useState } from "react";
import { DismissRegular } from "@fluentui/react-icons";
import {
  MessageBar,
  MessageBarActions,
  MessageBarTitle,
  MessageBarBody,
  Button,
  Link,
} from "@fluentui/react-components";
import { makeStyles } from "@fluentui/react-components";
import { JoinMenu } from "../JoinMenu";
const useStyles = makeStyles({
  wrapper: {
    position: "absolute",
    top: "3%",
    zIndex: "1000",
    right: "3%",
  },
});
export const SwitchCall = ({ joinNow }) => {
  const styles = useStyles();
  const [open, setOpen] = useState(true);

  // If dismissed → render nothing
  if (!open) return null;
  return (
    <div className={styles.wrapper}>
      <MessageBar>
        <MessageBarBody>
          <MessageBarTitle>Join the Call on this Device.</MessageBarTitle>
        </MessageBarBody>
        <MessageBarActions
          containerAction={
            <Button
              aria-label="dismiss"
              appearance="transparent"
              icon={<DismissRegular />}
              onClick={() => setOpen(false)}
            />
          }
        >
          {/* <Button
            appearance="primary"
            shape="circular"
            onClick={() => joinNow && joinNow(true)}
          >
            Join Now
          </Button> */}
          <JoinMenu joinNow={joinNow} />
        </MessageBarActions>
      </MessageBar>
    </div>
  );
};
